module.exports = __webpack_public_path__ + "img/req_sale.0106e5c4.png";